/**
 * Get the logged in user data from localStorage
 */
export const getUserData = () => {
  const userData = localStorage.getItem('DuttonAuthUser')
  return userData ? JSON.parse(userData) : null
}

/**
 * Check if user is admin
 */
export const isAdmin = () => {
  const userData = getUserData()
  return userData && userData.role === 'admin'
}

/**
 * Check if user is vendor
 */
export const isVendor = () => {
  const userData = getUserData()
  return userData && userData.role === 'vendor'
}
